if (typeof window.stockmansteaks === "undefined") {
  window.stockmansteaks = {
    // Attributes
    data: {
      isPromotionsInitialized: false,
      promotions: null,
    },
    
    // Methods
    debounce: (func, wait) => {
      let timeout;
      return function(...args) {
        const context = this;
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(context, args), wait);
      };
    },
    saveLocalStorage: (key, value) => {
      if (typeof key !== 'string') {
        throw new Error('Key must be a string');
      }

      const augmentedKey = `ss-${key}`;
      localStorage.setItem(augmentedKey, JSON.stringify(value));
    },
    loadLocalStorage: (key) => {
      if (typeof key !== 'string') {
        throw new Error('Key must be a string');
      }

      const augmentedKey = `ss-${key}`;
      const item = localStorage.getItem(augmentedKey);
      try {
        return item ? JSON.parse(item) : null;
      } catch (e) {
        console.error('Failed to parse stored JSON:', e);
        return null;
      }
    },
    clearLocalStorage: (key) => {
      if (typeof key !== 'string') {
        throw new Error('Key must be a string');
      }
      
      const augmentedKey = `ss-${key}`;
      localStorage.removeItem(augmentedKey);
    },
    loadPromotions: async(codes) => {
      const url = `https://app.stockmansteaks.com.au/storefront/api/v1/shopify-promo-items?code=${codes.join(',')}&show_items=1`
      const response = await fetch(url, {
        method: "GET",
        mode: "cors",
        credentials: "omit",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      })
        .then((response) => response.json())

      if (response.status) {
        window.stockmansteaks.data.promotions = response.data;
        window.stockmansteaks.renderPromotionInCart();
      }
    },
    renderPromotionInCart: () => {
      // Delete all
      document.querySelectorAll('[data-promotion-item]').forEach((el) => {
        el.remove();
      });

      if (window.stockmansteaks.data.promotions) {
        const tbody = document.querySelector('#main-cart-items tbody');
        if (!tbody) {
          return;
        }
        
        const template = `
          <tr class="cart-item" data-promotion-item>
            <td class="cart-item__media">
              <a href="{{ product_url }}" class="cart-item__link" aria-hidden="true" tabindex="-1"> </a>
              <div class="cart-item__image-container gradient global-media-settings">
                <img
                  src="{{ product_image_url }}&width=300"
                  class="cart-item__image" alt="" loading="lazy" width="150" height="143">
              </div>
            </td>

            <td class="cart-item__details">
              <a href="{{ product_url }}"
                class="cart-item__name h4 break" role="link">{{ product_title }}</a>
              <div class="cart-item__discounted-prices">
                <span class="visually-hidden">
                  Regular price
                </span>
                <s class="cart-item__old-price product-option">{{ product_price }}</s>
                <span class="visually-hidden">
                  Sale price
                </span>
                <strong class="cart-item__final-price product-option">
                  $0.00
                </strong>
              </div>
              <dl></dl>
              <p class="product-option"></p>
              <ul class="discounts list-unstyled" role="list" aria-label="Discount">
                <li class="discounts__discount">
                  <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-discount color-foreground-text"
                    viewBox="0 0 12 12">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M7 0h3a2 2 0 012 2v3a1 1 0 01-.3.7l-6 6a1 1 0 01-1.4 0l-4-4a1 1 0 010-1.4l6-6A1 1 0 017 0zm2 2a1 1 0 102 0 1 1 0 00-2 0z"
                      fill="currentColor">
                    </path>
                  </svg>
                  Free Promo Item
                </li>
              </ul>
            </td>

            <td class="cart-item__totals right medium-hide large-up-hide">
              <div class="loading-overlay hidden">
                <div class="loading-overlay__spinner">
                  <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66"
                    xmlns="http://www.w3.org/2000/svg">
                    <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                  </svg>
                </div>
              </div>
              <div class="cart-item__price-wrapper">
                <dl class="cart-item__discounted-prices">
                  <dt class="visually-hidden">
                    Regular price
                  </dt>
                  <dd>
                    <s class="cart-item__old-price price price--end">
                      {{ product_price }}
                    </s>
                  </dd>
                  <dt class="visually-hidden">
                    Sale price
                  </dt>
                  <dd class="price price--end">
                    $0.00
                  </dd>
                </dl>
              </div>
            </td>

            <td class="cart-item__quantity">
              <div class="cart-item__quantity-wrapper">
                <label class="visually-hidden" for="Quantity-1">
                  Quantity
                </label>
                <quantity-input class="quantity">
                  <input class="quantity__input" type="number" value="{{ quantity }}" min="0" disabled />
                </quantity-input>
              </div>
              <div class="cart-item__error" id="Line-item-error-1" role="alert">
                <small class="cart-item__error-text"></small>
                <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-error" viewBox="0 0 13 13">
                  <circle cx="6.5" cy="6.50049" r="5.5" stroke="white" stroke-width="2"></circle>
                  <circle cx="6.5" cy="6.5" r="5.5" fill="#EB001B" stroke="#EB001B" stroke-width="0.7"></circle>
                  <path
                    d="M5.87413 3.52832L5.97439 7.57216H7.02713L7.12739 3.52832H5.87413ZM6.50076 9.66091C6.88091 9.66091 7.18169 9.37267 7.18169 9.00504C7.18169 8.63742 6.88091 8.34917 6.50076 8.34917C6.12061 8.34917 5.81982 8.63742 5.81982 9.00504C5.81982 9.37267 6.12061 9.66091 6.50076 9.66091Z"
                    fill="white"></path>
                  <path
                    d="M5.87413 3.17832H5.51535L5.52424 3.537L5.6245 7.58083L5.63296 7.92216H5.97439H7.02713H7.36856L7.37702 7.58083L7.47728 3.537L7.48617 3.17832H7.12739H5.87413ZM6.50076 10.0109C7.06121 10.0109 7.5317 9.57872 7.5317 9.00504C7.5317 8.43137 7.06121 7.99918 6.50076 7.99918C5.94031 7.99918 5.46982 8.43137 5.46982 9.00504C5.46982 9.57872 5.94031 10.0109 6.50076 10.0109Z"
                    fill="white" stroke="#EB001B" stroke-width="0.7">
                  </path>
                </svg>
              </div>
            </td>

            <td class="cart-item__totals right small-hide">
              <div class="loading-overlay hidden">
                <div class="loading-overlay__spinner">
                  <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66"
                    xmlns="http://www.w3.org/2000/svg">
                    <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                  </svg>
                </div>
              </div>

              <div class="cart-item__price-wrapper">
                <dl class="cart-item__discounted-prices">
                  <dt class="visually-hidden">
                    Regular price
                  </dt>
                  <dd>
                    <s class="cart-item__old-price price price--end">
                      {{ product_price }}
                    </s>
                  </dd>
                  <dt class="visually-hidden">
                    Sale price
                  </dt>
                  <dd class="price price--end">
                    $0.00
                  </dd>
                </dl>
              </div>
            </td>
          </tr>
        `;

        const cartSubtotal = Number(document.querySelector(".totals__subtotal-value")?.innerHTML.replace(/[^0-9.]/g, '') || 0);

        let hasDisplayPromo = false;
        window.stockmansteaks.data.promotions.forEach((promotion) => {
          const { minSubtotal, items } = promotion;

          // Ignore if the cart subtotal is less than the minimum required for the promotion
          if (cartSubtotal < minSubtotal) {
            return;
          }

          if (hasDisplayPromo) {
            return;
          }

          items.forEach((item) => {
            const { variation, quantity } = item;

            if (!variation) {
              return;
            }
            
            // Replace placeholders with actual values
            const filledTemplate = template
              .replace(/{{ product_url }}/g, variation.product.onlineStoreUrl)
              .replace(/{{ product_image_url }}/g, variation.product.featuredImage.url)
              .replace(/{{ product_title }}/g, variation.product.title)
              .replace(/{{ product_price }}/g, `$${variation.price}`)
              .replace(/{{ quantity }}/g, quantity);

            // Append the filled template into the tbody
            tbody.insertAdjacentHTML("beforeend", filledTemplate);
          });

          hasDisplayPromo = true;
        });
      }
    },
    addItem: async (payload = {}) => {
      const cartNotification = document.querySelector("cart-notification");

      const variantId = payload.variantId;
      const quantity = payload.quantity;
      const properties = payload.properties || undefined;
      const ignoreAddonsModal = payload.ignoreAddonsModal || false;
      const refreshedSections = payload.refreshedSections || "cart-notification-product,cart-notification-button,cart-icon-bubble";

      let url = window.routes.cart_add_url;

      if (ignoreAddonsModal) {
        url += "?ignore-addons-modal=1";
      }

      // Ensure variantId and quantity are provided
      if (!variantId || !quantity) {
        console.error("Variant ID and quantity are required.");
        return;
      }

      // Prepare the data for the AJAX request
      const data = {
        id: variantId,
        quantity: quantity,
        properties: properties,
        sections: refreshedSections,
      };

      // Make the AJAX request to Shopify's cart add endpoint
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(data),
      })
        .then((response) => response.json())
        .then((response) => {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: "product-form",
            productVariantId: variantId,
            cartData: response,
          });

          cartNotification.renderContents(response);

          window.stockmansteaks.replaceSections(response);
          window.stockmansteaks.toggleCartEmpty(response.item_count === 0);
        })
        .catch((error) => {
          console.error("There was a problem with the fetch operation:", error);
        });

      return response;
    },
    autoAddItemInProductPage: () => {
      const autoAddValue =
        window.stockmansteaks.getQueryParam("auto-add") || null;
      const variantId = document.querySelector("input[name=id]")?.value || null;

      if (autoAddValue && variantId) {
        window.stockmansteaks.addItem({
          variantId: variantId,
          quantity: 1,
          ignoreAddonsModal: 1,
        });
      }
    },
    toggleCartEmpty: (isEmpty) => {
      const cartFooter = document.getElementById("main-cart-footer");
      const cartItems = document.querySelector("cart-items");

      if (cartFooter) {
        cartFooter.classList.toggle("is-empty", isEmpty);
      }

      if (cartItems) {
        cartItems.classList.toggle("is-empty", isEmpty);
      }
    },
    getCartSectionsToRender: () => {
      // NOTE: `section` must be the *section id* (as rendered in the JSON template),
      // not the section file/type name. Requesting a section by its file name makes
      // Shopify render it standalone, without any of the blocks configured in the
      // template, so block driven markup (.js-contents, .cart__ctas, ...) is missing
      // from the response.
      return [
        {
          id: 'main-cart-items',
          section: document.getElementById('main-cart-items')?.dataset.id || 'main-cart-items',
          selector: ['.js-contents'],
        },
        {
          id: 'cart-icon-bubble',
          section: 'cart-icon-bubble',
          selector: ['.shopify-section'],
        },
        {
          id: 'cart-live-region-text',
          section: 'cart-live-region-text',
          selector: ['.shopify-section'],
        },
        {
          id: 'main-cart-footer',
          section: document.getElementById('main-cart-footer')?.dataset.id || 'main-cart-footer',
          selector: ['.js-contents', '.cart__ctas', '.cart__ctas-addon'],
        }
      ];
    },
    getCartSectionsParam: () => {
      return window.stockmansteaks
        .getCartSectionsToRender()
        .map((section) => section.section)
        .join(',');
    },
    replaceSections: (response) => {
      if (!response || !response.sections) {
        return;
      }

      const sectionsToRender = window.stockmansteaks.getCartSectionsToRender();

      function getSectionHTML(section) {
        // Sections can come back keyed by the requested id, but older calls still
        // request them by file name - support both.
        return response.sections[section.section] ?? response.sections[section.id] ?? null;
      }

      function getSectionInnerHTML(html, selector) {
        return new DOMParser()
          .parseFromString(html, 'text/html')
          .querySelector(selector)?.innerHTML;
      }

      sectionsToRender.forEach((section) => {
        const sectionHTML = getSectionHTML(section);

        if (!sectionHTML) {
          return;
        }

        section.selector.forEach((selector => {
          const elementToReplace = document.getElementById(section.id)?.querySelector(selector) || document.getElementById(section.id);

          if (!elementToReplace) {
            return;
          }

          const innerHTML = getSectionInnerHTML(sectionHTML, selector);

          // Never blow away live markup with `undefined` when the selector is
          // missing from the rendered section.
          if (typeof innerHTML !== 'string') {
            console.warn(`replaceSections: "${selector}" not found in section "${section.section}"`);
            return;
          }

          elementToReplace.innerHTML = innerHTML;
        }));
      });

      const cartItemsSection = sectionsToRender.find((section) => section.id === 'main-cart-items');
      const cartItemsHTML = cartItemsSection ? getSectionHTML(cartItemsSection) : null;

      if (cartItemsHTML) {
        const SCRIPT_ID = 'modal-change-type-possibility';
        const changeTypePossibilityInnerHTML = getSectionInnerHTML(cartItemsHTML, `#${SCRIPT_ID}`);

        if (typeof changeTypePossibilityInnerHTML === 'string') {
          const oldScript = document.querySelector(`#${SCRIPT_ID}`);

          if (oldScript) {
            oldScript.remove();
          }

          const newScript = document.createElement("script");
          newScript.id = SCRIPT_ID;
          newScript.type = "text/javascript";
          newScript.text = changeTypePossibilityInnerHTML;
          document.body.appendChild(newScript);
        }
      }

      window.stockmansteaks.renderPromotionInCart();
      window.stockmansteaks.initCuratedBoxSizeToggles();
    },
    updateTickProgress: (el, pct) => {
      const clamped = Math.max(0, Math.min(100, pct));
      el.dataset.progressValue = clamped;
      el.style.setProperty("--progress", clamped / 100);
      el.classList.toggle("ss-tick-progress--done", clamped >= 100);
    },
    getQueryParam: (key) => {
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.get(key);
    },
    validateRequiredScripts: async (timeout = 2000) => {
      const start = Date.now();

      while (true) {
        const hasJQuery = typeof window.jQuery === "function";

        if (hasJQuery) {
          break;
        }

        if (Date.now() - start >= timeout) {
          break;
        }

        await new Promise(resolve => setTimeout(resolve, 50)); // wait 50ms before rechecking
      }
    },
    changeTab: ($el) => {
      const $parent = $el.parent();
      const $target = $($el.data('target'));

      // Change on tab pill
      $parent.find('.active').removeClass('active');
      $el.addClass('active');

      // Update tab pane
      if ($target.length) {
        const $tabPaneParent = $target.parent();

        $tabPaneParent.find('.tab-pane').addClass('hidden');
        $target.removeClass('hidden');
      }

    },
    initTabs: () => {
      $(document).on('click', '[data-toggle="tab"]', function(e) {
        e.preventDefault();

        window.stockmansteaks.changeTab($(this));
      })
    },
    initDiscounts: async () => {
      if (window.stockmansteaks.isPromotionsInitialized) {
        return;
      }

      const appliedDiscountCodes = window.appliedDiscountCodes || [];

      if (appliedDiscountCodes.length) {
        await window.stockmansteaks.loadPromotions(window.appliedDiscountCodes);
      }

      window.stockmansteaks.isPromotionsInitialized = true;
    },
    initAddToBuildABox: () => {
      document.addEventListener("click", function (e) {
        const target = e.target.closest('[data-trigger="add-to-build-a-box"]');
        if (!target) return;

        const value = target.getAttribute("data-value");
        const qty = target.getAttribute("data-qty");
        const baseUrl = "/products/build-a-box/";

        if (!value) {
          console.warn('Missing data-value for data-trigger="add-to-build-a-box"');
        }

        try {
          // Check localStorage support
          if (typeof localStorage !== "undefined") {
            if (value) {
              localStorage.setItem("ss-build-a-box-auto-append", value);
              localStorage.setItem("ss-build-a-box-auto-append-qty", Number(qty) || 1);
            }

            window.location.href = baseUrl;
          } else {
            // Fallback if localStorage doesn't exist
            window.location.href = baseUrl + (value ? "?add=" + encodeURIComponent(value) : "");
          }
        } catch (err) {
          // Extra safety net if localStorage access errors out
          window.location.href = baseUrl + (value ? "?add=" + encodeURIComponent(value) : "");
        }
      });
    },
    initCuratedBoxSizeToggles: () => {
      if (typeof jQuery === 'undefined') return;
      
      const $toggleGroups = $('.curated-box-size-toggle');
      
      // Remove any existing event handlers to prevent duplicates
      $toggleGroups.off('change', 'input[type="radio"]');
      $toggleGroups.off('keydown', 'input[type="radio"]');
      
      $toggleGroups.each(function() {
        const $toggleGroup = $(this);
        const cardId = $toggleGroup.data('card-id');
        const $radios = $toggleGroup.find('input[type="radio"]');
        const $cardWrapper = $toggleGroup.closest('.card-wrapper');
        
        // Get data from the toggle group's data attributes
        const sizeData = {
          medium: {
            variantId: $toggleGroup.data('medium-variant-id'),
            boxCount: $toggleGroup.data('medium-box-count')
          },
          large: {
            variantId: $toggleGroup.data('large-variant-id'),
            boxCount: $toggleGroup.data('large-box-count')
          }
        };
        
        // Handle radio change
        $radios.on('change', function() {
          const selectedSize = $(this).val();
          const data = sizeData[selectedSize];
          
          // Find all elements with data-size in this card
          const $currentVisible = $cardWrapper.find('[data-size]:not(.hidden)');
          const $newVisible = $cardWrapper.find(`[data-size="${selectedSize}"]`);
          
          // Static toggle - no animation
          $currentVisible.addClass('hidden');
          $newVisible.removeClass('hidden');
          
          // Update form fields
          const $form = $cardWrapper.find('form[data-type="add-to-cart-form"]');
          $form.find('input[data-variant-id]').val(data.variantId);
          $form.find('input[data-box-count]').val(data.boxCount);
        });
        
        // Keyboard navigation (arrow keys)
        $radios.on('keydown', function(e) {
          const $current = $(this);
          let $next = null;
          
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
            e.preventDefault();
            $next = $current.parent().next().find('input[type="radio"]');
            if ($next.length === 0) {
              $next = $toggleGroup.find('input[type="radio"]').first();
            }
          } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
            e.preventDefault();
            $next = $current.parent().prev().find('input[type="radio"]');
            if ($next.length === 0) {
              $next = $toggleGroup.find('input[type="radio"]').last();
            }
          }
          
          if ($next && $next.length > 0) {
            $next.prop('checked', true).focus().trigger('change');
          }
        });
      });
    },
    init: async () => {
      // Init something that doesn't require jquery
      window.stockmansteaks.initAddToBuildABox();

      // The rest require other plugins
      await window.stockmansteaks.validateRequiredScripts();
      window.stockmansteaks.autoAddItemInProductPage();
      window.stockmansteaks.initCuratedBoxSizeToggles();
      window.stockmansteaks.initDiscounts();
      window.stockmansteaks.initTabs();
    },
  };

  window.stockmansteaks.init();
}
